import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { mixpanel } from '@/mixpanel'
import { CareQuestionDetailContentLayout } from '@/modules/care-question/components/care-question-detail-content-layout/CareQuestionDetailContentLayout'

export const CareQuestionFlowBlockedPage = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  useHideNativeNavigation()

  const handleGoBack = () => {
    mixpanel.track('care_question_flow_blocked_go_back')
    navigate(-1)
  }

  const handleClose = () => {
    mixpanel.track('care_question_flow_blocked_close_flow')
    navigate('/', { replace: true })
  }

  const handleMakeAppointment = () => {
    mixpanel.track('care_question_flow_blocked_make_appointment')
    navigate('/appointment')
  }

  return (
    <CareQuestionDetailContentLayout
      header={{
        primaryAction: {
          label: t({
            id: 'globals.go-back',
            message: 'Terug',
          }),
          icon: ['far', 'chevron-left'],
          onClick: handleGoBack,
        },
        secondaryAction: {
          label: t({
            id: 'globals.close',
          }),
          icon: ['fal', 'times'],
          onClick: handleClose,
        },
      }}
      bottom={
        <Button variant='Primary' onClick={handleMakeAppointment}>
          {t({
            id: 'patient-communication.unavailable.appointment',
            message: 'Afspraak maken',
          })}
        </Button>
      }
    >
      <StContentContainer gap={theme.UI.Spacing.Space6}>
        <H2 noMargin>
          {t({
            id: 'care-question.question-blocked.title',
            message:
              'De door jou geselecteerde zorgverlener en/of dienst is momenteel niet beschikbaar voor online zorgvragen.',
          })}
        </H2>

        <P type='BodyMediumRegular' style={{ fontWeight: 400 }}>
          {t({
            id: 'care-question.question-blocked.description',
            message: 'Neem contact op met je ziekenhuis via telefoon of e-mail, of maak een afspraak.',
          })}
        </P>
      </StContentContainer>
    </CareQuestionDetailContentLayout>
  )
}

const StContentContainer = styled(FlexColumn)`
  justify-content: flex-end;
  flex-grow: 1;

  @media (${breakpoints.fromS}) {
    justify-content: flex-start;
  }
`
